import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div data-testid="protected-loading" className="grid min-h-[60vh] place-items-center">
        <div className="h-8 w-8 animate-pulse rounded-full bg-[#D95D39]/50" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
